import {
  GET_TRAILER_CAR_BRAND_LIST_FAIL,
  GET_TRAILER_CAR_BRAND_LIST_REQUEST,
  GET_TRAILER_CAR_BRAND_LIST_SUCCESS,
  GET_TRAILER_CAR_MODEL_LIST_FAIL,
  GET_TRAILER_CAR_MODEL_LIST_REQUEST,
  GET_TRAILER_CAR_MODEL_LIST_SUCCESS,
} from "src/constants/types";

export const trailerCarBrandReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_TRAILER_CAR_BRAND_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_TRAILER_CAR_BRAND_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        trailerCarBrands: actions.payload,
        error: "",
      };
    case GET_TRAILER_CAR_BRAND_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_TRAILER_CAR_MODEL_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_TRAILER_CAR_MODEL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        trailerCarModels: actions.payload,
        error: "",
      };
    case GET_TRAILER_CAR_MODEL_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
